import React from "react";

const Header = ({ scrollToContact }) => {
  return (
    <>
      <header className="header">
        <div className="header-logo">
          <a href="https://www.expressearth.com" target="_blank">
            <img src="/logo512.png" alt="Logo" className="logo" />
          </a>
        </div>

        <div className="header-right">
          <div className="call-section">
            📞{" "}
            <a href="tel:+919266056660" className="phone-number">
              +91 92660 56660
            </a>
          </div>
          <button className="demo-btn" onClick={scrollToContact}>
            Get In Touch
          </button>
        </div>
      </header>

      <style>{`
        .header {
          width: 100%;
          padding: 10px 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: white;
          position: sticky;
          top: 0;
          z-index: 1000;
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
        }

        .header-logo img {
          height: 50px;
          width: auto;
        }

        .header-right {
          display: flex;
          align-items: center;
          gap: 20px;
        }

        .demo-btn {
          background: #007bff;
          color: white;
          border: none;
          padding: 10px 18px;
          border-radius: 6px;
          cursor: pointer;
          font-size: 14px;
          transition: 0.3s;
        }

        .demo-btn:hover {
          background: #0056b3;
        }

        .call-section {
          display: flex;
          align-items: center;
          gap: 8px;
          font-weight: 500;
          color: #333;
        }

        .phone-number {
          font-size: 16px;
          font-weight: 800;
        }

        /* Mobile Responsiveness */
        @media (max-width: 768px) {
          .header {
            padding: 10px 16px;
          }

          .header-logo img {
            height: 40px;
          }

          .header-right {
            gap: 12px;
          }

          .demo-btn {
            padding: 8px 14px;
            font-size: 13px;
          }

          .phone-number {
            font-size: 14px; /* smaller number on mobile */
          }
        }

        @media (max-width: 480px) {
          .header {
            padding: 8px 12px;
          }

          .header-right {
            gap: 8px;
          }

          .demo-btn {
            padding: 6px 12px;
            font-size: 12px;
          }

          .phone-number {
            font-size: 13px; /* even smaller on very small screens */
          }
        }
      `}</style>
    </>
  );
};

export default Header;
